import { UserProperties } from '@itential/analytics-service';
import { CloudAuthSignedInState, ControlToken, useCloudAuth } from '@itential/cloud-auth-client';

export function useGetUserProperties(): UserProperties {
    const { state } = useCloudAuth();
    const signedIn = state as CloudAuthSignedInState;

    const controlToken = signedIn?.decodedControlToken as ControlToken;
    const itentialEnv = window.location.hostname;
    const itentialSessionId = signedIn?.decodedControlToken?.sid ?? '';
    const orgId = signedIn?.realm;
    const userEmail = signedIn?.email;
    const userName = `${signedIn?.givenName} ${signedIn?.familyName}`;
    const userPermissions = controlToken?.resource_access?.control?.roles;
    const permissionSource = typeof controlToken?.aud === 'string' ? [controlToken?.aud] : controlToken?.aud;

    const userProp = {
        itentialEnvironment: itentialEnv,
        itentialSessionId: itentialSessionId,
        organizationId: orgId,
        userEmail: userEmail,
        userName: userName,
        userPermissions: userPermissions ?? [],
        permissionSources: permissionSource ?? [],
    };

    return userProp;
}
